const ExternalEndPoint = {
    Actions: {
        Actions: "SendActionStatus", 
    }, 
  };
  export default ExternalEndPoint;
  